<template>
  <form-block
    :title="tr('Site links')"
    :description="tr('Potentially help increase conversions by giving people more ways to learn and buy.')"
  >
    <info-text v-if="siteLinksCount == 1" type="info">
      {{ tr('Currently, :count site link is configured for creating new ads.', { ':count': siteLinksCount }) }}
    </info-text>
    <info-text v-else-if="siteLinksCount > 1" type="info">
      {{ tr('Currently, :count site links are configured for creating new ads.', { ':count': siteLinksCount }) }}
    </info-text>

    <info-text v-if="siteLinksCount > 0 && siteLinksCount < 4" type="error">
      {{ tr('Site links are already configured, but at least 4 are required to use them when creating new ads.') }}
    </info-text>

    <ui-button class="w-fit" :disabled="disabled" @click="() => openSiteLinksModal()">
      <link-icon />
      {{ tr('Manage site links') }}
    </ui-button>
  </form-block>
</template>

<script>
import { Link } from '@lucide/vue';

import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import InfoText from '@/ui/components/InfoText.vue';
import SiteLinksModal from '@/ui/components/SiteLinksModal.vue';

export default {
  name: 'SiteLinksBlock',
  components: {
    InfoText,
    LinkIcon: Link,
  },
  mixins: [ RuleFormBlockMixin ],
  computed: {
    siteLinksCount() {
      return (this.entity.settings.site_links || []).length;
    },
  },
  methods: {
    openSiteLinksModal() {
      this.$fullscreenModal.open(
        this,
        SiteLinksModal,
        {
          modelValue: this.entity.settings.site_links || [],
          disabled: this.disabled,
        },
        {
          closeWithOutclick: false,
          componentListeners: {
            'update:modelValue': updatedSiteLinks => {
              this.entity.settings.site_links = updatedSiteLinks;
            },
          },
        },
      );
    },
    validate() {
      const siteLinks = this.entity.settings.site_links || [];
      if (siteLinks.length > 0 && siteLinks.length < 4) {
        this.error(this.tr('You need at least 4 site links. Currently you have :count.', { ':count': siteLinks.length }));
        return false;
      }
      return true;
    },
  },
};
</script>
